import { useFormContext } from "react-hook-form";

import { capitaliseSentence } from "../../services/capitaliseSentence";
import { InputT, TimeKeyT } from "../../types/database/forms";
import { timeUnits } from "@patient-watch/types";
import { RichLabel } from "@patient-watch/forms";
import { formComponents as fc } from "@/features/i18n/formComponents";
import { ui } from "@patient-watch/ui";

interface _TimeValue {
    interval: number;
    timeUnit: TimeKeyT;
}

interface Props {
    form: any;
    input: InputT;
}

const Duration = ({ form: _form, input }: Props) => {
    const { control: _control } = useFormContext();

    // const {
    // 	field: { value, onChange },
    // } = useController<TimeValue>({
    // 	name: input.input_id,
    // 	control: form.control,
    // });

    // const handleIntervalChange = (newInterval: number) => {
    // 	onChange({ interval: newInterval, timeUnit: value?.timeUnit ?? 'day' });
    // };

    // const handleTimeUnitChange = (newTimeUnit: TimeKeyT) => {
    // 	onChange({ interval: value?.interval ?? 0, timeUnit: newTimeUnit });
    // };

    return (
        <>
            <ui.Label>
                <RichLabel>{input.input_label}</RichLabel>
                {!input.is_optional && <span className="ml-0.5 text-red-500">*</span>}
            </ui.Label>
            <div className="flex justify-center items-start gap-2">
                <fc.Number name={`${input.input_id}.interval`} />
                <fc.Select
                    name={`${input.input_id}.timeUnit`}
                    options={Object.keys(timeUnits).map((t) => {
                        return { value: t, label: capitaliseSentence(t) };
                    })}
                />
            </div>
            {input.input_description && <p className="font-normal text-slate-700 text-sm">{input.input_description}</p>}
        </>
    );
};

export default Duration;
